import { ReactNode } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Placement } from "react-bootstrap/esm/types";
import styled from "styled-components";

const StyledHintIcon = styled.button`
  background: none;
  border: 0;
  padding: 0 0 0 5px;
  color: inherit;
  font-size: 14px;
  line-height: inherit;
  cursor: pointer;
`;

const StyledTooltipContent = styled.span`
  text-align: left;
  display: inline-block;
`;

const HintIconContainer = styled.div`
  display: flex;
  gap: 5px;
`;

const HintIcon = ({
  className,
  children,
  placement,
  variant = "hint",
}: {
  className?: string;
  children: ReactNode;
  placement?: Placement;
  // "hint" poses a question; "info" annotates a value.
  variant?: "hint" | "info";
}) => {
  const tooltip = (
    <Tooltip style={{ position: "fixed" }}>
      <StyledTooltipContent>{children}</StyledTooltipContent>
    </Tooltip>
  );
  const icon = variant === "info" ? "bi-info-circle" : "bi-question-circle";
  return (
    <OverlayTrigger overlay={tooltip} placement={placement}>
      <StyledHintIcon
        type="button"
        aria-label={variant === "info" ? "Details" : "Help"}
        className={`${className} bi ${icon}`}
      />
    </OverlayTrigger>
  );
};

export default Object.assign(HintIcon, { Container: HintIconContainer });
